import axios from "axios";
import { IP } from "../index.js";
/* 问答列表-全部 */
export async function selectRecordListAll(data) {
  var resp = await axios.post(`${IP}/admin/answersRecord/list_all`, data);
  return resp.data;
}

/* 问答列表-付费 */
export async function selectRecordList(data) {
  var resp = await axios.post(`${IP}/admin/answersRecord/list`, data);
  return resp.data;
}

/* 问答记录 */
export async function selectRecordDetails(data) {
  var resp = await axios.post(`${IP}/admin/answersRecord/details`, data);
  return resp.data;
}

/* 新增 */
export async function addRecord(data) {
  var resp = await axios.post(`${IP}/admin/answersRecord/add`, {
    ...data,
  });
  return resp.data;
}

/* 修改 */
export async function updateRecord(data) {
  var resp = await axios.post(`${IP}/admin/answersRecord/update`, {
    ...data,
  });
  return resp.data;
}

/* 删除 */
export async function deleteRecord(data) {
  var resp = await axios.post(`${IP}/admin/answersRecord/delete`, data);
  return resp.data;
}

/* 发送短信 */
export async function send(data) {
  var resp = await axios.post(`${IP}/admin/answersRecord/send`, data);
  return resp.data;
}

/* 更新AI/人工回复状态 */
export async function updateAuto(data) {
  var resp = await axios.post(`${IP}/admin/answersRecord/updateAuto`, data);
  return resp.data;
}


/* 问答提取列表 */
export async function answersExtractSelect(data) {
  var resp = await axios.post(`${IP}/admin/answersExtract/list`, data);
  return resp.data;
}

/* 问答提取列表删除 */
export async function answersExtractDelete(data) {
  var resp = await axios.post(`${IP}/admin/answersExtract/delete`, data);
  return resp.data;
}
